import {view, StripeLogo, Divider, tokens} from '@sail/ui';
import {Link, Text} from 'src/v2/components/common';

import {message, useIntl} from '@sail/intl';

const messages = {
  poweredByStripe: message<{
    stripeLogo: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.footer.powered_by_stripe',
    description: 'Text indicating that the page is built by Stripe',
    defaultMessage: 'Powered by {stripeLogo}',
  }),

  terms: message({
    id: 'crypto.payins.v2.footer.terms',
    description: 'Link to the Stripe terms of service',
    defaultMessage: 'Terms',
  }),

  privacy: message({
    id: 'crypto.payins.v2.footer.privacy',
    description: 'Link to the Stripe privacy policy',
    defaultMessage: 'Privacy',
  }),
};

export const Footer = () => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        stack: 'x',
        height: 'fit',
        alignX: 'center',
        alignY: 'center',
        gap: 'medium',
      }}
      data-testid="v2-footer"
    >
      <Link
        href="https://stripe.com"
        type="primary"
        target="_blank"
        css={{stack: 'x', alignY: 'center'}}
      >
        <Text
          type="caption"
          css={{color: tokens.color.neutral[500].toString()}}
        >
          {intl.formatMessage(messages.poweredByStripe, {
            stripeLogo: (
              <StripeLogo
                key="stripe-logo"
                css={{
                  height: 'medium',
                  verticalAlign: 'middle',
                }}
              />
            ),
          })}
        </Text>
      </Link>
      <Divider />
      <view.span css={{stack: 'x', gap: 'small', width: 'fit'}}>
        <Link
          href="https://stripe.com/legal/consumer"
          type="primary"
          target="_blank"
          css={{stack: 'x', alignY: 'center'}}
        >
          <Text
            type="caption"
            css={{color: tokens.color.neutral[500].toString()}}
          >
            {intl.formatMessage(messages.terms)}
          </Text>
        </Link>
        <Link
          href="https://stripe.com/privacy"
          type="primary"
          target="_blank"
          css={{stack: 'x', alignY: 'center'}}
        >
          <Text
            type="caption"
            css={{color: tokens.color.neutral[500].toString()}}
          >
            {intl.formatMessage(messages.privacy)}
          </Text>
        </Link>
      </view.span>
    </view.div>
  );
};
